
import { Component, Inject, Vue } from "vue-property-decorator";
import { Container } from "inversify";
import MobileFilterModal from "./MobileFilterModal.vue";
import ServiceFilter from "../filters/ServiceFilter.vue";
import ProductFilter from "../filters/ProductFilter.vue";
import OperatingRegimeFilter from "../filters/OperatingRegimeFilter.vue";
import ApplicationFilter from "../filters/ApplicationFilter.vue";
import { FlashNewsFilterStore } from "../../../stores/flashNews/FlashNewsFilterStore";
import { handleError } from "../../../../../common/src/utility/errorUtils";
import { ApplicationTypeStore } from "../../../../../common/src/stores/ApplicationTypeStore";
import { ProductTypeStore } from "../../../../../common/src/stores/ProductTypeStore";
import { ServiceTypeStore } from "../../../../../common/src/stores/ServiceTypeStore";
import { OperatingRegimeTypeStore } from "../../../../../common/src/stores/OperatingRegimeTypeStore";

@Component({
    components: {
        MobileFilterModal,
        ProductFilter,
        ServiceFilter,
        ApplicationFilter,
        OperatingRegimeFilter,
    },
})
export default class FlashNewsMobileSidebar extends Vue {
    @Inject("container") readonly container!: Container;
    flashNewsFilterStore: FlashNewsFilterStore = this.container.get(FlashNewsFilterStore);
    readonly applicationFilterStore: ApplicationTypeStore = this.container.get(
        "FlashNewsApplicationTypeStore",
    );
    readonly serviceFilterStore: ServiceTypeStore = this.container.get("FlashNewsServiceTypeStore");
    readonly productFilterStore: ProductTypeStore = this.container.get("FlashNewsProductTypeStore");
    readonly operatingRegimeFilterStore: OperatingRegimeTypeStore = this.container.get(
        "FlashNewsOperatingRegimeTypeStore",
    );

    created() {
        this.applicationFilterStore.load().catch(handleError);
        this.serviceFilterStore.load().catch(handleError);
        this.productFilterStore.load().catch(handleError);
        this.operatingRegimeFilterStore.load().catch(handleError);
    }
}
